export class RuntimeAPIError extends Error {
  constructor(message, { status, reason, runtimeAccess, payment } = {}) {
    super(message);
    this.name = 'RuntimeAPIError';
    this.status = status;
    this.reason = reason;
    this.runtimeAccess = runtimeAccess;
    this.payment = payment;
  }
}

export async function createRuntimeApiError(response) {
  const errorData = await response.json().catch(() => ({}));
  return new RuntimeAPIError(
    errorData.error || errorData.message || `HTTP ${response.status}`,
    {
      status: response.status,
      reason: errorData.reason,
      runtimeAccess: errorData.runtime_access,
      payment: errorData.payment,
    },
  );
}

export function isRuntimePaymentRequired(error) {
  return error?.status === 402 || error?.runtimeAccess?.payment_required === true;
}
